import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';

const contractFactory = require('./IMdexFactory.json')
const contractInfo = require('./IMdexPair.json')

// let web3 = $web3js.getWeb3Main();
let web3 = $web3js.getWeb3();
let contractMap = new Map();
let contractAddress = $bizConfig.idmexPairContractAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractFactory.abi, contractAddress) : '',
}

const handleContractEmpty = (_defaultValue) => {
    return new Promise((resolve, reject) => {
        resolve(_defaultValue);
    })
}

const getIMdexFactoryAddress = () => {
    return contractAddress;
}

const getIMdexFactoryContract = () => {
    return contractConst.contract;
}

const getPair = (tokenA, tokenB) => {
    return $web3js.call(getIMdexFactoryContract().methods.getPair, [tokenA, tokenB]);
}

const getIMdexPairContract = (_contractAddress) => {
    let _iMdexPairContract = contractMap.get(_contractAddress);
    if (!_iMdexPairContract) {
        try {
            _iMdexPairContract = web3 ? new web3.eth.Contract(contractInfo.abi, _contractAddress) : '';
        } catch (error) {
            Vue.prototype.$toast(error && error.message ? error.message : error);
        }
        if (!!_iMdexPairContract) {
            contractMap.set(_contractAddress, _iMdexPairContract)
        }
    }
    return _iMdexPairContract;
}

const getToken0 = async(_contractAddress) => {
    let contract = getIMdexPairContract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.token0);
}

const getToken1 = async(_contractAddress) => {
    let contract = getIMdexPairContract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.token1);
}

const getReserves = async(_pair) => {
    let contract = getIMdexPairContract(_pair);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.getReserves, [], {}, handleReserves, [_pair]);
}

const getPairTotalSupply = async(_pair) => {
    let contract = getIMdexPairContract(_pair);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.totalSupply, [], {}, $web3js.fromWei);
}


const handleReserves = async(res, _pair) => {
    // console.log(res)
    let index = 0;
    let reserve0 = res[index++];
    let reserve1 = res[index++];
    let blockTimestampLast = res[index++];

    let token0 = await getToken0(_pair);
    let token1 = await getToken1(_pair);
    reserve0 = await $erc20.fromErc20Value(reserve0, token0);
    reserve1 = await $erc20.fromErc20Value(reserve1, token1);

    return {
        reserve0,
        reserve1,
        blockTimestampLast,
        token0,
        token1,
    }
}

const getPairPrice = async(_pair) => {
    if (!_pair || _pair == $bizConfig.noneAddress) {
        return "0";
    }
    let price = "0";
    await getReserves(_pair)
        .then((res) => {
            // console.log(res)
            price = Vue.prototype.$numberUtils.div(
                res.reserve0,
                res.reserve1,
                18,
                1
            );
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    return price;
}

const getPairReversePrice = async(_pair) => {
    if (!_pair || _pair == $bizConfig.noneAddress) {
        return "0";
    }
    let price = "0";
    await getReserves(_pair)
        .then((res) => {
            // console.log(res)
            price = Vue.prototype.$numberUtils.div(
                res.reserve1,
                res.reserve0,
                18,
                1
            );
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    return price;
}

const getQuantityPerHusd = async(_contractAddress) => {
    // let _husdAddress = $bizConfig.husdContractAddress.toLowerCase();
    if (!getIMdexFactoryAddress()) {
        return "0";
    }
    // let _husdAddress = "0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047".toLowerCase();
    let _husdAddress = $erc20.getErc20Address("USDT");
    if (!_contractAddress || !_contractAddress.trim()) {
        return "0";
    }
    if (_contractAddress.toLowerCase() == _husdAddress) {
        return "1";
    }
    // if (_contractAddress.toLowerCase() == $bizConfig.ifilTokenContractAddress.toLowerCase()) {
    //   return getQuantityPerHusdV2(_contractAddress);
    // }
    // if (_contractAddress.toLowerCase() == $bizConfig.ixchTokenContractAddress.toLowerCase()) {
    //   return getQuantityPerHusdV3(_contractAddress);
    // }
    let quantityPerHusd = "0";
    let pair = "";
    await getPair(_contractAddress, _husdAddress)
        .then((res) => {
            pair = res;
        })
        .catch((error) => {
            // console.log(error)
            // Vue.prototype.$toast(error && error.message ? error.message : error);
        });
    if (!pair || pair == $bizConfig.noneAddress) {
        return "0";
    }
    await getReserves(pair)
        .then((res) => {
            if (_husdAddress == res.token0.toLowerCase()) {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve0,
                    res.reserve1,
                    18,
                    1
                );
            } else {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve1,
                    res.reserve0,
                    18,
                    1
                );
            }
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    return quantityPerHusd;
}

const getQuantityPerHusdV2 = async(_contractAddress) => {
    // let _husdAddress = $bizConfig.husdContractAddress.toLowerCase();
    let _husdAddress = "0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047".toLowerCase();
    let _usdtAddress = "0xa71edc38d189767582c38a3145b5873052c3e47a".toLowerCase();
    if (!_contractAddress || !_contractAddress.trim()) {
        return "0";
    }
    if (_contractAddress.toLowerCase() == _husdAddress) {
        return "1";
    }
    let quantityPerHusd = "0";
    let pair = "";
    await getPair(_contractAddress, _usdtAddress)
        .then((res) => {
            pair = res;
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    if (!pair || pair == $bizConfig.noneAddress) {
        return "0";
    }
    await getReserves(pair)
        .then((res) => {
            if (_usdtAddress == res.token0.toLowerCase()) {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve0,
                    res.reserve1,
                    18,
                    1
                );
            } else {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve1,
                    res.reserve0,
                    18,
                    1
                );
            }
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });

    let husd_usdt_pair = "0xdff86b408284dff30a7cad7688fedb465734501c";
    let husd_usdt_price = "";
    await getReserves(husd_usdt_pair)
        .then((res) => {
            husd_usdt_price = Vue.prototype.$numberUtils.div(
                res.reserve0,
                res.reserve1,
                18,
                1
            );
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    return Vue.prototype.$numberUtils.mul(quantityPerHusd, husd_usdt_price, 18, 1);
}


const getQuantityPerHusdV3 = async(_contractAddress) => {
    let _toAddress = "0x854bb58fdda85f20b5ab20b20d888f0554c02560".toLowerCase();
    let quantityPerHusd = "0";
    let pair = "";
    await getPair(_contractAddress, _toAddress)
        .then((res) => {
            pair = res;
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });
    if (!pair || pair == $bizConfig.noneAddress) {
        return "0";
    }
    await getReserves(pair)
        .then((res) => {
            if (_toAddress == res.token0.toLowerCase()) {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve0,
                    res.reserve1,
                    18,
                    1
                );
            } else {
                quantityPerHusd = Vue.prototype.$numberUtils.div(
                    res.reserve1,
                    res.reserve0,
                    18,
                    1
                );
            }
        })
        .catch((error) => {
            // this.$toast(error && error.message ? error.message : error);
        });

    let toQuantityPerHusd = await getQuantityPerHusd(_toAddress)
    return Vue.prototype.$numberUtils.mul(quantityPerHusd, toQuantityPerHusd, 18, 1);
}

export default {
    getIMdexFactoryAddress,
    getIMdexFactoryContract,
    getIMdexPairContract,
    getReserves,
    getPair,
    getPairPrice,
    getPairReversePrice,
    getQuantityPerHusd,
    getQuantityPerHusdV2,
    getPairTotalSupply,
}


// WEBPACK FOOTER //
// ./src/lib/contract/IMdexPair/index.js